import {onViewportEnter} from '../helpers/lazyInit';
import RichContentReviews from './RichContentReviews';
import RichContentPageContent from './RichContentPageContent';

class CountryPageContent extends RichContentPageContent {
	constructor(params) {
		super(params);
		
		this.richContentReviews = this._createRichContentReviews();
		this.customInit();
	}
	
	customInit() {
		requestAnimationFrame(() => {
			this.richContentReviews.initBadge();
		});

		const reviewsBlock = document.querySelector('#reviews');

		if (reviewsBlock) {
			onViewportEnter(
				[reviewsBlock],
				() => this.richContentReviews.init()
			);
		}
	}

	_createRichContentReviews() {
		return new RichContentReviews({
			'reviewsData': {
				'countryId': this.getCurrentCountryId()
			},
			'getFetchContentUrl': ({countryId, imagesFirst, page}) => (
				`country/${countryId}/review/block_content/${page}/?imagesFirst=${imagesFirst}`
			)
		});
	}

	getCurrentCountryId() {
		return this.params.countryId;
	}

}

export default CountryPageContent;